export const insertAfter = (el: HTMLElement, referenceNode: HTMLElement) => {
  referenceNode.parentNode!.insertBefore(el, referenceNode.nextSibling);
};
